// Configure your import map in config/importmap.rb. Read more: https://github.com/rails/importmap-rails
import "@hotwired/turbo-rails";
import "./controllers";

import { startViewer } from "./three/viewer";

let cleanup = null;

document.addEventListener("turbo:load", () => {
  const el = document.getElementById("pano-viewer");
  if (!el) return;

  // ✅ Se non c'è scene-data, NON è la pagina viewer/show → non avviare startViewer
  const jsonEl = document.getElementById("scene-data");
  if (!jsonEl) return;

  let scene = null;
  try {
    scene = JSON.parse(jsonEl.textContent);
  } catch (e) {
    console.error("scene-data JSON non valido:", e);
    return;
  }

  cleanup?.();
  cleanup = startViewer(el, { scene });
});

document.addEventListener("turbo:before-cache", () => {
  cleanup?.();
  cleanup = null;
});
